export const GA_TRACKING_ID = 'GTM-W4V6'
